import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-lightShow" }
const _hoisted_2 = { class: "p-4 text-left space-y-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, [
  /*#__PURE__*/_createTextVNode(" 一度退会するとアカウントの復元ができません。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 退会申請後、1週間以内に反映され、完了時にはご登録いただいているSHOW公式LINEでお知らせいたします。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※予約中の特別優待がある場合など、退会処理の受付ができない場合があります。 ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-8" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "text-center block w-full items-center rounded-md border border-transparent bg-gray-showButton px-6 py-2 text-base font-medium text-white shadow-sm"
  }, " 退会する ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
        default: _withCtx(() => [
          _createTextVNode(" 退会理由 "),
          _createVNode(_component_Field, {
            modelValue: _ctx.reason,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reason) = $event)),
            as: "textarea",
            name: "reason",
            type: "text",
            class: "block w-full rounded-md border-gray-300 shadow-sm sm:text-sm focus:border-green-show focus:ring-green-show",
            placeholder: "",
            rules: "required"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_ErrorMessage, {
            name: "reason",
            class: "text-red-500 text-left"
          }),
          _hoisted_4
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}